import BybButtonVR from "@Components/game/common/buttons/byb-button/byb-button-vr";
import { BybVrDialogContent, BybVrDialogFooter, BybVrDialogHeader } from "@Components/game/common/dialog/byb-vr-dialog";
import { Button, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CareerStatusContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(4),
  display: "flex",
  boxSizing: "border-box",
  width: "100%",
}));

export const CareerInfoPanel = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "space-between",
  flex: 3,
  backdropFilter: `blur(${theme.spacing(1.25)})`,
  backgroundColor: `${theme.palette.dsSurface.v100}80`,
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.dsSurface.v400}80`,
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
  textAlign: "center",
  gap: theme.spacing(6),
}));

export const CareerProgressPanel = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  flex: 2,
  backdropFilter: `blur(${theme.spacing(1.25)})`,
  backgroundColor: `${theme.palette.dsSurface.v100}80`,
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.dsSurface.v400}80`,
  padding: theme.spacing(6),
}));

export const CareerActionsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(4),
  justifyContent: "center",
  width: "100%",
  alignItems: "center",
}));

export const AllPositionsButton = styled(Button)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: `${theme.palette.dsSurface.v300}80`,
  border: `${theme.spacing(0.25)} solid ${theme.palette.dsSurface.v400}80`,
  padding: theme.spacing(1.5, 2.5),
  cursor: "pointer",
  flex: 1,
  transition: "all 0.3s ease-in-out",
  color: theme.palette.dsBase.v200,
  "&:hover": {
    backgroundColor: `${theme.palette.dsSurface.v400}80`,
    border: `${theme.spacing(0.25)} solid ${theme.palette.dsSurface.v500}80`,
  },
}));

export const CountdownDialogLayout = styled(Stack)(({ theme }) => ({
  minHeight: "100%",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));

export const CountdownDialogHeader = styled(BybVrDialogHeader)({
  justifyContent: "flex-start",
  padding: 0,
});

export const CountdownDialogTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.text4xl700,
  color: theme.palette.dsBase.v200,
}));

export const CountdownDialogContent = styled(BybVrDialogContent)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
  minHeight: theme.spacing(24),
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
}));

export const CountdownDialogFooter = styled(BybVrDialogFooter)({
  alignItems: "flex-end",
  padding: 0,
});

export const CountdownDialogCancelButton = styled(BybButtonVR)(({ theme }) => ({
  minWidth: theme.spacing(11),
  padding: theme.spacing(1.25, 2.5),
  backgroundColor: "transparent !important",
  border: "none !important",
  borderRadius: theme.spacing(1),
  boxShadow: `inset 0 0 0 1px ${theme.palette.dsDestructive.v300}`,
  "& .MuiTypography-root": {
    ...theme.typography.textBase700,
    color: `${theme.palette.dsDestructive.v300} !important`,
    opacity: "1 !important",
  },
  "&:hover": {
    backgroundColor: `${theme.palette.dsDestructive.v100}33 !important`,
    boxShadow: `inset 0 0 0 1px ${theme.palette.dsDestructive.v400}`,
    "& .MuiTypography-root": {
      color: `${theme.palette.dsDestructive.v400} !important`,
      opacity: "1 !important",
    },
  },
}));
